import { render, staticRenderFns } from "./ctrlDisplayTitle.vue?vue&type=template&id=3419249a&scoped=true&"
import script from "./ctrlDisplayTitle.vue?vue&type=script&lang=js&"
export * from "./ctrlDisplayTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3419249a",
  null
  
)

export default component.exports